import React, { useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import Form from "./Form";

function QrCode() {
  const handleChipClick = useOutletContext();

  useEffect(() => {
    handleChipClick("qr_code");
  }, [handleChipClick]);

  return <Form />;
}

export default QrCode;
